module.exports = __webpack_public_path__ + "img/dummyprod11@2x.3ee77f31.png";